import { useMemo } from 'react';
import * as Collections from '@pkg/utils/collections';
import config from '@/lib/config';
import { DesignEntity } from '@/lib/enums';
import { color } from '@/lib/theme/tokens';

const COLOR = {
  MAIN: {
    PRODUCTIVITY: color.core.blue,
    WORK_HEALTH: color.core.yellow,
  },
  BENCHMARK: {
    PRODUCTIVITY: color.core.navy,
    WORK_HEALTH: color.core.pink,
  },
};

/**
 * @param {Object} insights
 * @param {String} uuid
 * @returns {Object}
 */
export default function useInsights(insights, uuid) {
  return useMemo(() => {
    if (!insights || !uuid) {
      return null;
    }

    const benchmark = insights.organisation;
    const group = Collections.findById(insights.groups, uuid);

    return group.insights.map(({ key, summary, breakdown }, index) => ({
      key,
      title: config.INSIGHTS.CATEGORIES[key],
      labels: summary.map(({ key }) => config.INSIGHTS.METRICS[key]),
      summary: [
        {
          color: COLOR.MAIN[key],
          data: summary.map(({ value }) => value),
          label: 'Team',
        },
        {
          color: COLOR.BENCHMARK[key],
          data: benchmark[index].summary?.map(({ value }) => value),
          label: 'Organisation',
        },
      ],
      breakdown: breakdown?.map(({ uuid, metrics }) => ({
        uuid,
        type: DesignEntity.ROLE,
        data: metrics.map(({ value }) => value),
      })),
    }));
  }, [JSON.stringify(insights), uuid]);
}
